'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'house-night';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e010';
var svgPathData = 'M125.2-15.9c6.2-4.4 5.4-14.8-2.2-15.6-3.6-.4-7.3-.5-11-.5-61.9 0-112 50.1-112 112S50.1 192 112 192c32.1 0 61.1-13.5 81.5-35.2 5.2-5.6-1-14-8.6-13.2-2.9 .3-5.9 .4-9 .4-48.6 0-88-39.4-88-88 0-29.7 14.7-55.9 37.2-71.9zM560 336l19.9 0c15.5 0 28.1-12.6 28.1-28.1 0-7.6-3.1-14.9-8.6-20.2L395.5 91.1C388.1 84 378.3 80 368 80s-20.1 4-27.5 11.1L136.6 287.7c-5.5 5.3-8.6 12.6-8.6 20.2 0 15.5 12.6 28.1 28.1 28.1l19.9 0 0 144c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-144zM320 312c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM520 72L487.4 85c-4.5 1.8-7.4 6.1-7.4 11s2.9 9.2 7.4 11l32.6 13 13 32.6c1.8 4.5 6.1 7.4 11 7.4s9.2-2.9 11-7.4l13-32.6 32.6-13c4.5-1.8 7.4-6.1 7.4-11s-2.9-9.2-7.4-11L568 72 555 39.4c-1.8-4.5-6.1-7.4-11-7.4s-9.2 2.9-11 7.4L520 72zM245-24.6L232 8 199.4 21c-4.5 1.8-7.4 6.1-7.4 11s2.9 9.2 7.4 11L232 56 245 88.6c1.8 4.5 6.1 7.4 11 7.4s9.2-2.9 11-7.4L280 56 312.6 43c4.5-1.8 7.4-6.1 7.4-11s-2.9-9.2-7.4-11L280 8 267-24.6c-1.8-4.5-6.1-7.4-11-7.4s-9.2 2.9-11 7.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseNight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;